// extracted by mini-css-extract-plugin
export default {"container":"TeamInvitation_container__rf9d5","centered":"TeamInvitation_centered__U+gvI"};